import { render, staticRenderFns } from "./VisitSNA.vue?vue&type=template&id=31734105"
import script from "./VisitSNA.vue?vue&type=script&lang=js"
export * from "./VisitSNA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports